import React from 'react';
import cx from 'classnames';
import { Reveal } from 'react-reveal';

import { pluralize } from 'utilities/pluralize';

import { GreenButton, WhiteButton } from '@marketing/components/buttons';
import { OfferProps } from '@marketing/types';
import { defaultRegistrationUrl } from '@marketing/utilities';

import ConcentricCircles from './assets/concentric_circles.svg';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

interface Props {
  examName: string;
  pointIncrease?: number | string;
  primaryOffer: OfferProps & { name: string };
  secondaryOffer?: OfferProps & { name: string };
  trialOffer: OfferProps;
}

export default (props: Props) => {
  const pointIncreaseText = typeof props.pointIncrease === 'string' ? (
    props.pointIncrease
  ) : (
    `+${pluralize(props.pointIncrease, 'point')}`
  );

  return (
    <div className="align-items-center d-flex" style={{ minHeight: 400, position: 'relative' }}>
      <div
        style={{
          bottom: 0,
          left: '50%',
          position: 'absolute',
          top: 0,
          transform: 'scaleY(-1) translateX(-50%)',
          width: 1130,
          zIndex: -2
        }}
      >
        <img alt="" loading="lazy" src={ConcentricCircles} />
      </div>

      <div className={cx(styles.startYourPrepContainer, 'd-flex flex-1 flex-column gap-m')}>
        <Reveal duration={1000} effect={marketingStyles.fadeInAndSlideUp}>
          <h3 className="text-center u-margin-A-n" style={{ fontSize: 40 }}>
            <strong>Start your {props.examName} prep today!</strong>
          </h3>

          <div className="text-center" style={{ fontSize: 18 }}>
            Zero risk: 7-day “No questions asked” money-back guarantee
            <br />{props.pointIncrease ? `${pointIncreaseText} improvement` : 'Improve'} on your previous {props.examName} test. Guaranteed!
          </div>
        </Reveal>

        <div className="d-flex flex-column flex-lg-row gap-m justify-content-center">
          {
            props.secondaryOffer && (
              <WhiteButton href={defaultRegistrationUrl(props.secondaryOffer)}>
                Sign up for {props.secondaryOffer.name}
              </WhiteButton>
            )
          }
          <GreenButton href={defaultRegistrationUrl(props.primaryOffer)}>
            Sign up for {props.primaryOffer.name}
          </GreenButton>
        </div>

        <div className="text-center">
          <a className="small text-gray-light" href={defaultRegistrationUrl(props.trialOffer)}>
            Try Magoosh {props.examName} for 7 days with no commitment
          </a>
        </div>
      </div>
    </div>
  );
};
